export default "__VITE_ASSET__wCybDVbD__"